import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { utilService } from 'services/util-service';

interface LocationType {
  role: string | undefined;
  saveTime: number;
  lat: number;
  lng: number;
  acc: number;
  speed: number | null;
  heading: number | null;
}

const useWatchLocation = (options = {}) => {
  const { role: rawRole } = useParams();
  const role = utilService.normalizeRole(rawRole);
  const [location, setLocation] = useState<LocationType>();
  const [error, setError] = useState('');
  const locationWatchId = useRef(0);

  const handleSuccess = (pos) => {
    const { accuracy, heading, latitude, longitude, speed } = pos.coords;
    console.log('handleSuccess', pos);
    setLocation({
      role: role,
      saveTime: pos.timestamp,
      lat: latitude,
      lng: longitude,
      acc: accuracy,
      speed: speed,
      heading: heading,
    });
  };

  const handleError = (error) => {
    console.log('handleError', error.code);
    if (error.code === 3) setError('delayed');
    if (error.code === 1) setError('blocked');
  };

  const cancelLocationWatch = () => {
    const { geolocation } = navigator;

    if (locationWatchId.current && geolocation) {
      geolocation.clearWatch(locationWatchId.current);
    }
  };

  useEffect(() => {
    const { geolocation } = navigator;

    if (!geolocation) {
      setError('notSupport');
      return;
    }

    locationWatchId.current = geolocation.watchPosition(handleSuccess, handleError, options);

    return cancelLocationWatch;
  }, [options]);

  return { location, cancelLocationWatch, error };
};

export default useWatchLocation;
